"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
var react_1 = require("react");
function useIsMounted() {
    var mountedRef = react_1.useRef(false);
    react_1.useEffect(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    }, []);
    return mountedRef;
}
exports.useIsMounted = useIsMounted;
//# sourceMappingURL=useIsMounted.js.map